// extracted by mini-css-extract-plugin
export default {"club_card":"clubCard_club_card__IX07J","club_info":"clubCard_club_info__EFzBu"};